export function getUrlVars(url) {
    let qparams = {},
        parts = (url || '').split('?'),
        qparts, qpart,
        i = 0;

    if (parts.length <= 1) {
        return '';
    } else {
        qparts = parts[1].split('&');
        for (i in qparts) {
            qpart = qparts[i].split('=');
            qparams[decodeURIComponent(qpart[0])] = decodeURIComponent(qpart[1] || '');
        }
    }

    let qstring = '';
    for (i in qparts) {
        if (qstring.length == 0) {
            qstring = '?'
        } else {
            qstring = qstring + '&';
        }

        qstring = qstring + qparts[i];
    }

    return qstring;
}

export class LoadMore {

    constructor(getParameters, readyURL, allProducts, currentURL, limitProducts = 30, offsetProducts = 30) {
        this.getParameters = getParameters;
        this.readyUrl = readyURL;
        this.allProducts = allProducts;
        this.currentUrl = currentURL;
        this.offsetProducts = offsetProducts;
        this.limitProducts = limitProducts;

        this.otherProducts = allProducts - offsetProducts;
        this.showMoreProductsElement = document.getElementById('showMoreProducts');
        this.xhttp = new XMLHttpRequest();

        this.loaderElement = document.createElement('div');
        this.loaderElement.id = 'loadingProducts';
        this.loaderElement.innerHTML = '<div></div>';

        this.initScrollEvent();
    }

    initScrollEvent() {
        if (this.allProducts >= this.offsetProducts) {
            window.addEventListener('scroll', this.scrollEventListener = () => this.bindScroll());
        }
    }

    bindScroll() {
        if (this.otherProducts >= 0) {
            const productDescriptionBottom = document.getElementById('product-description-bottom');
            let triggerYpos = productDescriptionBottom ? productDescriptionBottom.getBoundingClientRect().top : document.getElementsByTagName('footer')[0].getBoundingClientRect().top;

            if (window.innerHeight > triggerYpos) {
                window.removeEventListener('scroll', this.scrollEventListener);
                this.loadMore();
            }
        }
    }

    loadMore() {
        this.xhttp.onreadystatechange = () => this.finalizeLoading();
        this.xhttp.open('GET', '/ajax/' + this.readyUrl + '/' + this.offsetProducts + '/' + this.limitProducts + '/' + this.currentUrl + this.getParameters, true);
        this.showMoreProductsElement.parentNode.insertBefore(this.loaderElement, this.showMoreProductsElement);
        this.xhttp.send();
    }

    finalizeLoading() {
        if (this.xhttp.readyState !== XMLHttpRequest.DONE) {
            return;
        }
        if (this.xhttp.status !== 200) {
            console.log('error');
            return;
        }

        console.log('finalizeLoading');

        let moreProductsElement = document.createElement('div');
        moreProductsElement.classList.add('products-more');
        moreProductsElement.innerHTML = this.xhttp.responseText;

        this.offsetProducts += this.limitProducts;
        this.showMoreProductsElement.parentNode.insertBefore(moreProductsElement, this.showMoreProductsElement);
        this.loaderElement.remove();

        this.initScrollEvent();
    }
}

export function displayMessages(messages) {

    if (!messages) {
        return;
    }

    const relativeFeedbacks = {};

    for (let message of messages) {
        if (message.feedback_class) {
            let inputs = document.getElementsByClassName(message.feedback_class);
            let inputFeedbackElement = null;
            let formFeedbackElement = null;

            for (let inputElement of inputs) {
                // Mark the input field
                inputElement.classList.add('is-' + message.state);

                // Check if the input field has a relative element (messages will be displayed in this element)
                const inputElementRel = inputElement.getAttribute('rel');
                let relElement = null;

                if (inputElementRel) {
                    relElement = document.getElementById(inputElementRel);
                }

                const form = inputElement.form;

                // If the form has a formFeedbackElement then display messages only in this container
                formFeedbackElement = form.querySelector('.form-control-feedback');

                inputFeedbackElement = document.createElement('div');
                inputFeedbackElement.innerHTML = message.message;
                inputFeedbackElement.classList.add(message.state + '-feedback');

                if (!formFeedbackElement && !inputElementRel) {
                    inputElement.after(inputFeedbackElement);
                }

                if (inputElementRel && relElement) {
                    if (!relativeFeedbacks[inputElementRel]) {
                        relativeFeedbacks[inputElementRel] = [];
                    }
                    if (!relativeFeedbacks[inputElementRel].includes(message.message)) {
                        relElement.append(inputFeedbackElement);
                    }

                    relativeFeedbacks[inputElementRel].push(message.message);
                }
            }

            if (formFeedbackElement && inputFeedbackElement) {
                formFeedbackElement.append(inputFeedbackElement);
            }
        }
    }
}

export function numberFormat(number, decimals, dec_point, thousands_sep) {
    number = (number + '')
        .replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + (Math.round(n * k) / k)
                .toFixed(prec);
        };
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
        .split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '')
        .length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1)
            .join('0');
    }
    return s.join(dec);
}

import { MarkerClusterer } from "@googlemaps/markerclusterer";
window.MarkerClusterer = MarkerClusterer;

import Scrollbar from 'smooth-scrollbar';
export {Scrollbar}
